import React from 'react'
import { Box, Stack } from '@mui/material'
import { useIsMobile } from '@/hooks/Responsive'

export default function SearchTabs({ currentTab, onChange, tabs }) {
  const { isMobile } = useIsMobile()

  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      sx={{
        mb: 6,
        gap: 1,
        '& > *': {
          flex: isMobile ? '0 0 calc(33% - 8px)' : '1 1 0',
        },
      }}
    >
      {tabs.map((t) => {
        const selected = currentTab === t.key

        return (
          <Box
            key={t.key}
            onClick={() => onChange(t.key)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '56px',
              borderRadius: 2,
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              fontWeight: '600',
              border: '1px solid',
              borderColor: selected ? 'grey.800' : 'divider',
              bgcolor: selected ? 'grey.800' : 'text.contrastText',
              color: selected ? 'text.contrastText' : 'grey.600',
              transition: 'all 0.2s ease',
            }}
          >
            {t.label} ({t.count}건)
          </Box>
        )
      })}
    </Stack>
  )
}